import { writable, readable, derived, get } from 'svelte/store';
import rpcjs from 'rpcjs';

const { api_init } = rpcjs.props;

export const title = writable('');

export const show = writable(0);

export const open_menu = writable(0);